import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";

export default function ProductSpecificationFields({ product, setProduct, disabled }) {
  const [error, setError] = useState("");
  const entries = Object.entries(product.specs || {});
  const update = (index, key, value) => setProduct((prev) => ({ ...prev,
    specs: Object.fromEntries(Object.entries(prev.specs || {}).map((entry, i) => i === index ? [key, value] : entry)),
  }));
  return (
    <section className="mb-4 p-3 border rounded" aria-label="Product specifications">
      <h5>Product specifications</h5>
      <p className="text-muted">Add details shared by every size, such as material or origin.</p>
      {entries.map(([key, value], index) => (
        <div key={index} className="row align-items-end mb-2">
          <Form.Group className="col-md-4">
            <Form.Label>Specification</Form.Label>
            <Form.Control required value={key} disabled={disabled} aria-label={`Specification name ${index + 1}`}
              onChange={(event) => {
                const next = event.target.value;
                if (entries.some(([name], i) => i !== index && name.trim() === next.trim())) {
                  setError("A specification with that name already exists.");
                  return;
                }
                setError("");
                update(index, next, value);
              }} />
          </Form.Group>
          <Form.Group className="col-md-6">
            <Form.Label>Value</Form.Label>
            <Form.Control value={String(value ?? "")} disabled={disabled} aria-label={`Specification value ${index + 1}`}
              onChange={(event) => update(index, key, event.target.value)} />
          </Form.Group>
          <div className="col-md-2"><Button type="button" variant="outline-danger" disabled={disabled}
            onClick={() => setProduct((prev) => ({ ...prev, specs: Object.fromEntries(Object.entries(prev.specs || {}).filter((_, i) => i !== index)) }))}>Remove</Button></div>
        </div>
      ))}
      {error && <p role="alert" className="text-danger">{error}</p>}
      <Button type="button" variant="outline-primary" disabled={disabled} onClick={() => setProduct((prev) => {
        let key = "New specification";
        while (Object.prototype.hasOwnProperty.call(prev.specs || {}, key)) key += " ";
        return { ...prev, specs: { ...prev.specs, [key]: "" } };
      })}>Add specification</Button>
    </section>
  );
}
